import React from 'react';
import { Anchor } from '@atlassiansox/bxp-content-framework';
import { getHeaderTheme } from '../themes';
import { useAnalytics, LogoTrello } from '../../../components';
export function HeaderLogo({ appearance, uuid }) {
    const { logoAppearance } = getHeaderTheme(appearance);
    const { sendTrackEvent } = useAnalytics();
    return (React.createElement(Anchor, { href: "/home", onClick: () => sendTrackEvent('clickedUiHeaderLogo', {
            event: 'clicked',
            eventComponent: 'logo',
            eventContainer: 'uiHeader',
            label: 'Trello logo',
            uuid: `${uuid}_logo`,
            href: '/home'
        }), "data-uuid": `${uuid}_logo`, testId: "logo_link" },
        React.createElement(LogoTrello, { width: 126, appearance: logoAppearance })));
}
//# sourceMappingURL=HeaderLogo.js.map